import { createAction } from '@reduxjs/toolkit';
import { PhonePrefix } from '../../services/phonePrefix/phonePrefix';
import { EventsToPayload } from 'formify-sdk/dist/events/domain';

export const setPhonePrefix = createAction<PhonePrefix[]>('config/setPhonePrefix');

export const setIframeSettings = createAction<EventsToPayload['setSetting']>('config/setIframeSettings');
